import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertRuleApi } from '../../../apis/AlertRuleApi/AlertRuleApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export function useDeleteAlertRuleConfiguration() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.alertRuleConfigurations, 'delete'],
        mutationFn: async (configId: number) => {
            return await AlertRuleApi.deleteAlertRuleConfiguration(configId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertRuleConfigurations] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.journalAlertConfigurations] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.questionnaireAlertConfigurations] });
            notifications.show({
                title: t('notification.success'),
                message: t('alertRule.notifications.configurationDeleted'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
